import { PropertyType } from 'esa-ui-library/lib/types';
import { reportConstants } from '../../constants/reports';
import { TableHeaderType, formatToISO, OptionType } from '../../../common';

export const getFiltersUrl = (filters: PropertyType[]): string => {
	const urlFragments: string[] = [];
	const searchValueObject = filters.find((f) => f.name === 'q');
	const hasSessionID = !!filters.find((f) => f.value === 'session_ids' || f.value === 'aams_session_ids');

	// Session id filter recived as searchType but has to be sent as session_ids='values'
	// so additional formatting is needed
	filters.forEach((f) => {
		if (
			(f.value !== 'session_ids' && f.value != 'aams_session_ids' && f.name !== 'q') ||
			(f.name === 'q' && !hasSessionID)
		) {
			const value = f.name == 'start_date' || f.name == 'end_date' ? formatToISO(f.value) : f.value;
			urlFragments.push(`${f.name}=${value}`);
		} else if ((f.value === 'session_ids' || f.value == 'aams_session_ids') && searchValueObject?.value) {
			urlFragments.push(`${f.value}=${searchValueObject?.value}`);
		}
	});
	const fitlersQuery = `?${urlFragments.join('&')}`;
	return fitlersQuery;
};

export const filterSessionFieldsByEnv = (fields: TableHeaderType[]): TableHeaderType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter(
			(f) => f.label !== reportConstants.REPORT_AAMS_TICKET_ID && f.label !== reportConstants.REPORT_WRB
		);
	}

	return result;
};

export const filterSearchOptionsByEnv = (fields: OptionType[]): OptionType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.value !== 'aams_ticket_ids');
	}

	return result;
};
